import { Util } from '@grandvisionhq/forms'

const { isValidPostalCodeForCountry } = Util.validations

export const eircodeValidator = (value: string) => {
  return isValidPostalCodeForCountry('IE', value)
}

export const isValidBirthDate = (value: string): boolean => {
  const [year, month, day] = value.split('-')
  if (!year || !month || !day) {
    return false
  }

  return Util.validations.isValidBirthDate(year, month, day)
}

/**
 * Check the validity of an Irish "Personal Public Service number".
 */
export const isPPSN = (value: string): boolean => {
  if (typeof value !== 'string') {
    return false
  }
  value = value.replace(REGEX.WHITESPACE, '').toUpperCase()
  if (!REGEX.PPSN.test(value)) {
    return false
  }
  let sum = 0
  for (let i = 0; i < 7; i++) {
    const checkedValue = value[i]
    if (checkedValue !== undefined) {
      sum += (8 - i) * parseInt(checkedValue, 0)
    }
  }
  if (value[8] && value[8] !== 'W') {
    sum += 9 * (value.charCodeAt(8) - 64)
  }
  return sum % 23 === value.charCodeAt(7) - 64
}

export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)

const REGEX = {
  PPSN: /^\d{7}[A-Z]{1,2}$/,
  WHITESPACE: /\s/g,
  ORDER_NUMBER: /^1\d{9}$/,
}
